import React, { useState } from "react";

import Sidebar from "../Sidebar";
import Footer from "../../components/common/Footer";

import "../../assets/css/admin/adminHomeMedia.css";

import { CLOUDINARY_URL, UPLOAD_PRESET } from "../../services/cloudinary";

import { db } from "../../firebase/firebase";

import { doc, setDoc } from "firebase/firestore";


function AdminHomeMedia() {

    const [mediaFile, setMediaFile] = useState(null);

    const [preview, setPreview] = useState("");

    const [mediaType, setMediaType] = useState("image");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});

    /*==========================================
            FILE SELECT
    ==========================================*/

   const handleFileChange = (e) => {

    const file = e.target.files[0];

    if (!file) return;

    setMediaFile(file);

    setPreview(URL.createObjectURL(file));

    setError("");

};

    /*==========================================
            UPLOAD MEDIA
    ==========================================*/

    const handleSubmit = async (e) => {

        e.preventDefault();

       if (!mediaFile) {

    setError("Please select a file.");

    return;

}

setError("");

        setLoading(true);

        try {

            const formData = new FormData();

            formData.append("file", mediaFile);

            formData.append("upload_preset", UPLOAD_PRESET);

            const response = await fetch(

                CLOUDINARY_URL,

                {

                    method: "POST",

                    body: formData

                }

            );

            const data = await response.json();

            if (!response.ok) {

                setPopup({
    show: true,
    type: "error",
    message: data.error?.message || "Upload Failed"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

return;

                

            }

            /*==========================================
                    SAVE TO FIRESTORE
            ==========================================*/

            if (mediaType === "image") {

                await setDoc(

                    doc(db, "website_settings", "home"),

                    {

                        heroImage: data.secure_url,

                        heroVideo: "",

                        mediaType: "image"

                    },

                    { merge: true }

                );

            }

            else {

                await setDoc(

                    doc(db, "website_settings", "home"),

                    {

                        heroVideo: data.secure_url,

                        heroImage: "",

                        mediaType: "video"

                    },

                    { merge: true }

                );

            }

            setPopup({
    show: true,
    type: "success",
    message: "Home Background Updated Successfully"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

            setMediaFile(null);

            setPreview("");

            document.getElementById("homeMedia").value = "";

        }

        catch (error) {

            console.log(error);

           setPopup({
    show: true,
    type: "error",
    message: "Upload Failed"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        }

        finally {

            setLoading(false);

        }

    };
    
    return (

        <>
           {popup.show && (

    <div className={`luxury-popup ${popup.type}`}>

        <div className="popup-icon">

            {popup.type === "success" ? "✓" : "✕"}

        </div>

        <div className="popup-content">

            <h3>

                {popup.type === "success"
                    ? "Success"
                    : "Error"}

            </h3>

            <p>{popup.message}</p>

        </div>

    </div>

)}
            <div className="admin-home-media-layout">

                <Sidebar />

                <div className="admin-home-media-container">

                    <form

                        className="admin-home-media-form"

                        onSubmit={handleSubmit}

                    >

                        <h1>

                            Luxury Home Background

                        </h1>

                        <p>

                            Upload a premium background image or a cinematic
                            video for your customer homepage.

                        </p>

                        {/* Media Type Selection */}
                                                {/*==========================================
                                MEDIA TYPE
                        ==========================================*/}

                        <div className="admin-media-type">

                            <label>

                                <input
                                    type="radio"
                                    name="mediaType"
                                    value="image"
                                    checked={mediaType === "image"}
                                    onChange={() => setMediaType("image")}
                                />

                                Background Image

                            </label>

                            <label>

                                <input
                                    type="radio"
                                    name="mediaType"
                                    value="video"
                                    checked={mediaType === "video"}
                                    onChange={() => setMediaType("video")}
                                />

                                Background Video

                            </label>

                        </div>

                        {/*==========================================
                                FILE INPUT
                        ==========================================*/}

                        <label className="admin-upload-label">

                            {
                                mediaType === "image"

                                    ? "Select Luxury Image"

                                    : "Select Cinematic Video"
                            }

                        </label>

                        <input

                            id="homeMedia"

                            type="file"

                            accept={
                                mediaType === "image"

                                    ? "image/*"

                                    : "video/*"
                            }

                            onChange={handleFileChange}

                        />
                        {error && (

    <p className="validation-error">

        {error}

    </p>

)}

                        {/*==========================================
                                PREVIEW
                        ==========================================*/}

                        {

                            preview && (

                                <div className="admin-media-preview">

                                    {

                                        mediaType === "image"

                                            ? (

                                                <img

                                                    src={preview}

                                                    alt="Preview"

                                                />

                                            )

                                            : (

                                                <video

                                                    src={preview}

                                                    controls

                                                    autoPlay

                                                    muted

                                                    loop

                                                />

                                            )

                                    }

                                </div>

                            )

                        }

                        {/*==========================================
                                BUTTON
                        ==========================================*/}

                        <button

                            type="submit"

                            className="admin-upload-btn"

                            disabled={loading}

                        >

                            {

                                loading

                                    ? "Uploading..."

                                    : mediaType === "image"

                                        ? "Upload Background Image"

                                        : "Upload Background Video"

                            }

                        </button>

                    </form>

                </div>

            </div>

            <Footer />

        </>

    );

}

export default AdminHomeMedia;